



import "./chart.js";
import "./sidebar.js"